import React, { FC, ReactNode, useEffect, useRef, useState } from 'react';
import { Grow } from '@material-ui/core';
import { Bubble, BubblePropsPositions, StyledPopover } from './BubbleTooltipStyled';

export type BubbleTooltipProps = {
  show: boolean;
  children: ReactNode;
  position?: BubblePropsPositions;
  parent?: DOMRect | null;
};

const BubbleTooltip: FC<BubbleTooltipProps> = ({ position = 'top', show, children, parent }) => {
  const bubbleRef = useRef<HTMLDivElement | null>(null);
  const [bubbleRect, setBubbleRect] = useState<DOMRect | null>(null);

  useEffect(() => {
    if (bubbleRef?.current) {
      setBubbleRect(bubbleRef?.current?.getBoundingClientRect());
    }
  }, []);

  return (
    <Grow in={show}>
      <StyledPopover>
        <Bubble position={position} ref={bubbleRef} rect={bubbleRect!}>
          {children}
        </Bubble>
      </StyledPopover>
    </Grow>
  );
};

export default BubbleTooltip;
